import { i18n } from '@/plugins/i18n';

export function parse_error_message(error_detail: any, request_type?: string) {
  if (request_type == undefined) {
    request_type = String(i18n.t('patients.requestTypeApplication'))
  }
  console.log('error_detail')
  console.log(error_detail)
  if (typeof error_detail === 'string' || error_detail instanceof String) {
    return error_detail
  }

  if (error_detail.detail && error_detail.detail.length <= 2) {
    const single_error = error_detail.detail[0];
    console.log('single_error')
    console.log(single_error)
    if (single_error.event_code == 'reject') {
      console.log('rejected');
      let detail_code = single_error.detail_code;
      if (detail_code == 'UNAUTHORIZED_STARTDATE_IN_CLAIM_BILLABLEPERIOD') {
        detail_code = String(i18n.t('patients.eAgreementErrors.invalidStartDate'))
      } else if (detail_code == 'UNAUTHORIZED_CLAIM_DUE_TO_EXISTING_IN_PROCESS_CLAIM') {
        detail_code = String(i18n.t('patients.eAgreementErrors.similarRequestInProgress'))
      } else if (detail_code == 'INVALID_SERVICEREQUEST_PRESCRIPTIONDATE') {
        detail_code = String(i18n.t('patients.eAgreementErrors.invalidPrescriptionOrConditionDate'))
      } else if (detail_code == 'INVALID_CLAIM_SERVICEDATE') {
        detail_code = String(i18n.t('patients.eAgreementErrors.invalidConditionDate'))
      } else if (detail_code == 'MISSING_PRESCRIPTION_IN_PHYSIO_CLAIM') {
        detail_code = String(i18n.t('patients.eAgreementErrors.missingPrescription'))
      } else if (detail_code == 'MISSING_MEDICALREPORT_ANNEX_IN_PHYSIO_CLAIM_SUPPORTINGINFO') {
        detail_code = String(i18n.t('patients.eAgreementErrors.missingMedicalReport'))
      } else if (detail_code == 'MISSING_RADIOLOGY_REPORT_ANNEX_IN_PHYSIO_CLAIM_SUPPORTINGINFO') {
        detail_code = String(i18n.t('patients.eAgreementErrors.missingRadiologyReport'))
      } else if (detail_code == 'MISSING_RADIOLOGY_PROTOCOL_ANNEX_IN_PHYSIO_CLAIM_SUPPORTINGINFO') {
        detail_code = String(i18n.t('patients.eAgreementErrors.missingRadiologyProtocol'))
      } else if (detail_code == 'MISSING_PERIMETRY_LYMPHOSCINTIGRAPHY_RESULTS_ANNEX_IN_PHYSIO_CLAIM_SUPPORTINGINFO') {
        detail_code = String(i18n.t('patients.eAgreementErrors.missingLymphoscintigraphyResults'))
      } else if (detail_code == 'UNAUTHORIZED_CLAIM_PREAUTHREF_INVALID_SUBTYPE') {
        detail_code = String(i18n.t('patients.eAgreementErrors.onlyCertainAgreementsExtendable'))
      } else if (detail_code == 'UNAUTHORIZED_CLAIM_DUE_TO_EXISTING_AGREEMENT') {
        detail_code = String(i18n.t('patients.eAgreementErrors.similarAgreementExists'))
      } else if (detail_code == 'UNAUTHORIZED_CLAIM_PREAUTHREF_WRONG_CAREPROVIDER') {
        detail_code = String(i18n.t('patients.eAgreementErrors.onlyRequesterCanArgueOrCancel'))
      } else if (detail_code == 'MISSING_ARGUMENTATION_IN_CLAIM') {
        detail_code = String(i18n.t('patients.eAgreementErrors.missingArgumentation'))
      } else if (detail_code == 'UNKNOWN_CLAIM_PREAUTHREF') {
        detail_code = String(i18n.t('patients.eAgreementErrors.unknownReference'))
      } else if (detail_code == 'UNAUTHORIZED_CLAIM_PREAUTHREF_NOT_EXTENDABLE') {
        detail_code = String(i18n.t('patients.eAgreementErrors.referenceNotExtendable'))
      } else if (detail_code == 'UNAUTHORIZED_CLAIM_PREAUTHREF_INVALID_PERIOD') {
        detail_code = String(i18n.t('patients.eAgreementErrors.invalidExtensionPeriod'))
      } else if (detail_code == 'INCONSISTENT_STARTDATE_IN_CLAIM_BILLABLEPERIOD') {
        detail_code = String(i18n.t('patients.eAgreementErrors.extensionStartDateMustBeAfterAgreement'))
      } else if (detail_code == 'INVALID_STARTDATE_IN_CLAIM_BILLABLEPERIOD') {
        detail_code = String(i18n.t('patients.eAgreementErrors.startDateMustBeDayAfterAgreement'))
      } else if (detail_code == 'UNAUTHORIZED_CLAIM_PREAUTHREF_NOT_CANCELLABLE') {
        detail_code = String(i18n.t('patients.eAgreementErrors.requestNotCancellable'))
      } else if (detail_code == 'UNAUTHORIZED_ADDITIONALINFO_IN_PHYSIO_CLAIM_SUPPORTINGINFO') {
        detail_code = String(i18n.t('patients.eAgreementErrors.additionalInfoNotAllowed'))
      } else if (detail_code == 'UNAUTHORIZED_AGREEMENT_TYPE_WITH_PATIENT_SITUATION') {
        detail_code = String(i18n.t('patients.eAgreementErrors.agreementAlreadyExistsForPathology'))
      } else if (detail_code == 'MISSING_ANNEX_OR_PRESCRIPTION_IN_PHYSIO_CLAIM') {
        detail_code = String(i18n.t('patients.eAgreementErrors.pleaseAttachMedicalOrPhysioReport'))
      } else if (detail_code == 'UNKNOWN_PRACTITIONER_IDENTIFIER') {
        if (single_error.practitioner_role == 'persphysiotherapist') {
          detail_code = String(i18n.t('patients.eAgreementErrors.physiotherapistUnknownAtMutuality'))
        } else {
          detail_code = String(i18n.t('patients.eAgreementErrors.invalidDoctorNihii'))
        }
      } else if (detail_code == 'MISSING_MEDICALREPORT_ANNEX_IN_PHYSIO_CLAIM_SUPPORTINGINFO') {
        detail_code = String(i18n.t('patients.eAgreementErrors.pleaseAttachMedicalReport'))
      } else if (detail_code == 'MISSING_SCOLIOSIS_PROTOCOL_ANNEX_IN_PHYSIO_CLAIM_SUPPORTINGINFO') {
        detail_code = String(i18n.t('patients.eAgreementErrors.pleaseAttachScoliosisProtocol'))
      } else if (detail_code.includes('but must be \'application/pdf\'')) {
        detail_code = String(i18n.t('patients.eAgreementErrors.onlyPdfAttachmentsAllowed'))
      } else if (detail_code == 'MISSING_CLAIM_BILLABLEPERIOD') {
        detail_code = String(i18n.t('patients.eAgreementErrors.unexpectedExtensionError'));// TODO na te zien indien dit voorkomt, zie mail Siska
      } else if (detail_code == 'INVALID_PATTERN_PRACTITIONER_IDENTIFIER_VALUE_(VALUE)') {
        detail_code = String(i18n.t('patients.eAgreementErrors.invalidPrescriberNihii'))
      } else if (detail_code == 'UNAUTHORIZED_ANNEX_IN_PHYSIO_CLAIM_SUPPORTINGINFO') {
        detail_code = String(i18n.t('patients.eAgreementErrors.onlyOneAnnexTypeAllowed'))
      } else if (detail_code == 'UNAUTHORIZED_PRESCRIPTION_IN_PHSYIO_CLAIM_SUPPORTINGINFO') {
        detail_code = String(i18n.t('patients.eAgreementErrors.previousPrescriptionOnlyForSecondSeries'))
      }
      return String(i18n.t('patients.eAgreementErrors.rejectedPrefix', { request: request_type, detail: detail_code }));
    } else if (single_error.event_code == 'refusal') {
      console.log('rejected');
      let detail_code = single_error.detail_code;
      if (detail_code == 'REF_AGREE_SRV_PHYSIO_010') {
        detail_code = String(i18n.t('patients.eAgreementErrors.refusalAge'))
      } else if (detail_code == 'REF_AGREE_SRV_PHYSIO_015') {
        detail_code = String(i18n.t('patients.eAgreementErrors.refusalAge'))
      } else if (detail_code == 'REF_AGREE_SRV_PHYSIO_001') {
        detail_code = String(i18n.t('patients.eAgreementErrors.refusalExistingAgreement'))
      } else if (detail_code == 'REF_AGREE_SRV_PHYSIO_004') {
        detail_code = String(i18n.t('patients.eAgreementErrors.refusalTooManyPathologySeries'))
      } else if (detail_code == 'REF_AGREE_SRV_PHYSIO_014') {
        detail_code = String(i18n.t('patients.eAgreementErrors.refusalAge'))
      } else if (detail_code && i18n.te(`patients.eAgreementErrors.refusalCodes.${detail_code}`)) {
        detail_code = String(i18n.t(`patients.eAgreementErrors.refusalCodes.${detail_code}`))
      }
      return String(i18n.t('patients.eAgreementErrors.rejectedPrefix', { request: request_type, detail: detail_code }));
    } else if (single_error.event_code == 'search-type') {
      console.log('bundle issue');
      const diagnostics_code = single_error.diagnostics_code.split('(')[0];
      return String(i18n.t('patients.eAgreementErrors.requestErrorPrefix', { code: diagnostics_code }));
    }
  }
  return error_detail.message ?? '';
}